module.exports = __webpack_public_path__ + "static/media/screenshot.5c112826.jpg";